import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  inputSearch: {
    '&.rounded': {
      '& .MuiInputBase-root.MuiOutlinedInput-root': {
        borderRadius: '100px',
      },
    },

    '& input': {
      paddingLeft: '0 !important',
    },
  },

  svg: {
    color: theme.palette.brand.gray[400],
  },
}));
